import API from '../../api/api';
import * as actionTypes from '../actionTypes';
import {message} from 'antd';

function cancellaDocumento(uuid,nomeDocumento,apiPath){
  return (dispatch) => {
    API.getAxios(apiPath).post(`cancellaDocumento?id=${uuid}&nomeDoc=${nomeDocumento}`)
      .then(() => {
        dispatch({type: actionTypes.LOADING_CONFERMA_FALSE});
      })
      .catch(errore => { 
        dispatch({type: actionTypes.LOADING_CONFERMA_FALSE});
        message.error(`Errore ${errore.response.data.errorCode}: ${errore.response.data.errorMessage}`,15);
      })
  };
}

export default cancellaDocumento;